import {gql, useQuery} from '@apollo/client';
import {useEffect} from "react";

const GET_USER_TRENDS = gql`
  query GetUserTrends {
      userTrends {
        atsLosses
        atsWins
        id
        isAtsTrend
        isDefaultTrend
        isDefaultUserTrend
        isOuTrend
        isSuTrend
        losses
        oPoints
        overs
        points
        trend
        sport
        trendDescription
        unders
        wins
      }
  }
`;

export const useGetUserTrends = (
    skip: boolean = false,
) => {
    const { data, loading, error, refetch } = useQuery(GET_USER_TRENDS, {
        skip,
    });

    useEffect(() => {
        if (!skip) {
            refetch();
        }
    }, [skip]);

    return {
        data,
        loading,
        error,
        refetch,
    };
}